import React, { Component } from 'react';
import { Route, Redirect, Switch } from 'react-router';
import { connect } from 'react-redux';

import { login } from '../../actions';

import ConfigureReport from './ConfigureReport';
import { SCFUsageCode } from '../../constants/reportConfig';
import ConfigureSCUsageReportContainer from './ConfigureSCUsageReport';

class Content extends Component {
  render() {
    return (
      <div className='Content'>
        <Switch>
          <Route
            path='/reports/configure/:reportCode?'
            render={
              (route) => {
                if (route.match.params.reportCode === SCFUsageCode) {
                  return <ConfigureSCUsageReportContainer reportCode={route.match.params.reportCode}
                    {...this.props} />
                }

                return <ConfigureReport
                  reportCode={route.match.params.reportCode}
                  {...this.props}
                />
              }}
          />
          <Route render={() => (
            <Redirect to='/' />
          )} />
        </Switch>
      </div>
    );
  }
}

export default connect(state => state, {
  login,
})(Content);



// WEBPACK FOOTER //
// ./src/containers/Reports/Reports.js